import React from "react";

function Youtube(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 18 18" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9051 5.03545C16.7153 4.32566 16.1563 3.7665 15.4464 3.57676C14.1596 3.23205 8.9999 3.23205 8.9999 3.23205C8.9999 3.23205 3.84028 3.23205 2.55354 3.57676C1.84361 3.7665 1.28458 4.32566 1.09484 5.03545C0.75 6.32233 0.75 9.00693 0.75 9.00693C0.75 9.00693 0.75 11.6917 1.09484 12.9784C1.28458 13.6882 1.84361 14.2475 2.55354 14.4371C3.84028 14.7819 8.9999 14.7819 8.9999 14.7819C8.9999 14.7819 14.1596 14.7819 15.4464 14.4371C16.1563 14.2475 16.7153 13.6882 16.9051 12.9784C17.2499 11.6917 17.2499 9.00693 17.2499 9.00693C17.2499 9.00693 17.2499 6.32233 16.9051 5.03545Z"
        fill="#FF0000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.3501 11.4819L11.6367 9.00701L7.3501 6.53185V11.4819Z"
        fill="white"
      />
    </svg>
  );
}

const MemoYoutube = React.memo(Youtube);
export default MemoYoutube;
